import { Content } from 'src/contexts/ContentContext';
import { Checkbox } from 'src/core/interim/Checkbox/Checkbox';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './TicketGroupInputTable.css';

export const TicketGroupInputTableHeader = ({
  isTotalCostChecked,
  setIsTotalCostChecked,
  hideToggle = false,
}: {
  isTotalCostChecked: boolean;
  setIsTotalCostChecked: (value: React.SetStateAction<boolean>) => void;
  /** Hides the "Add total costs" toggle (e.g. when total cost is forced on). */
  hideToggle?: boolean;
}) => {
  return (
    <div className={styles.tableHeader} data-testid="ticket-groups-header">
      <Content id={ContentId.TicketGroups} />
      {!hideToggle && (
        <div
          className={styles.headerCheckboxSection}
          data-testid="add-total-costs-toggle"
        >
          <Checkbox
            checked={isTotalCostChecked}
            onChange={() => {
              setIsTotalCostChecked((prev) => !prev);
            }}
            className={styles.headerCheckbox}
          />
          <Content id={ContentId.AddTotalCosts} />
        </div>
      )}
    </div>
  );
};
